"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SpecialImageCaption = _interopRequireDefault(require("../../SpecialImageCaption"));

var _Carousel = _interopRequireDefault(require("../../../darkmatter/Carousel"));

var _IndicatorGroup = _interopRequireDefault(require("../../../organisms/ImageCollection/components/IndicatorGroup"));

require("./SpecialCarousel.css");

var _SpecialCategory = _interopRequireDefault(require("./SpecialCategory"));

var _utils = require("../utils");

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var SpecialCarousel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SpecialCarousel, _React$Component);

  var _super = _createSuper(SpecialCarousel);

  function SpecialCarousel() {
    (0, _classCallCheck2["default"])(this, SpecialCarousel);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SpecialCarousel, [{
    key: "renderContent",
    value: function renderContent(data) {
      var _this$props = this.props,
          autoScroll = _this$props.autoScroll,
          showIndicator = _this$props.showIndicator,
          groupByCategory = _this$props.groupByCategory,
          categories = _this$props.specials.categories;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          overflowY: "hidden",
          overflowX: "hidden"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '140%',
          marginLeft: '-20%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Carousel["default"], {
        totalNumberOfItems: data.length,
        autoScroll: autoScroll,
        numberOfDisplayItems: 3
      }, function (_ref) {
        var currentIndex = _ref.currentIndex,
            changeCurrentIndex = _ref.changeCurrentIndex,
            getDisplayItemIndices = _ref.getDisplayItemIndices;
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
          columns: 3
        }, getDisplayItemIndices().map(function (index) {
          return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react["default"].createElement(_SpecialImageCaption["default"], (0, _extends2["default"])({
            image: data[index].image,
            name: data[index].name,
            description: data[index].description,
            variations: data[index].variations
          }, !groupByCategory && {
            category: (0, _utils.getCategoryNameFromItems)(data[index].id, categories)
          })));
        })), showIndicator && /*#__PURE__*/_react["default"].createElement("div", {
          className: "special-carousel-center-indicator-groups"
        }, /*#__PURE__*/_react["default"].createElement(_IndicatorGroup["default"], {
          images: data,
          currentIndex: currentIndex,
          changeCurrentIndex: changeCurrentIndex
        })));
      })));
    }
  }, {
    key: "renderWithCategory",
    value: function renderWithCategory() {
      var _this = this;

      var specials = this.props.specials;
      return /*#__PURE__*/_react["default"].createElement(_SpecialCategory["default"], {
        specials: specials
      }, function (data) {
        return _this.renderContent(data.items);
      });
    }
  }, {
    key: "renderWithoutCategory",
    value: function renderWithoutCategory() {
      var specials = this.props.specials;
      var special_items = specials.items.filter(function (data) {
        return data.is_special;
      });
      return this.renderContent(special_items);
    }
  }, {
    key: "render",
    value: function render() {
      var groupByCategory = this.props.groupByCategory;
      return groupByCategory ? this.renderWithCategory() : this.renderWithoutCategory();
    }
  }]);
  return SpecialCarousel;
}(_react["default"].Component);

SpecialCarousel.propTypes = {
  specials: _propTypes["default"].shape({
    schedules: _propTypes["default"].array,
    categories: _propTypes["default"].array,
    items: _propTypes["default"].array,
    modifierSets: _propTypes["default"].array,
    modifiers: _propTypes["default"].array
  }).isRequired,
  groupByCategory: _propTypes["default"].bool,
  autoScroll: _propTypes["default"].bool,
  showIndicator: _propTypes["default"].bool
};
SpecialCarousel.defaultProps = {
  autoScroll: true,
  showIndicator: true,
  groupByCategory: false
};
var _default = SpecialCarousel;
exports["default"] = _default;